import script from "./BuyNewProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyNewProxy.vue?vue&type=script&setup=true&lang=js"

import "./BuyNewProxy.vue?vue&type=style&index=0&id=9578e912&lang=css"

const __exports__ = script;

export default __exports__